import { css } from 'styled-components';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton } from '@mui/material';

interface ColoredButtonProps {
  color: string;
}

export const MarginButton = styled(Button)`
  margin-left: 6px;
`;

export const MarginIconButton = styled(IconButton)`
  margin-left: 6px;
`;

export const SMALL_ACTION_ICON_BUTTON_SIZE = '34px';
export const MEDIUM_ACTION_ICON_BUTTON_SIZE = '40px';

export const getActionIconButtonSize = (size?: 'large' | 'medium' | 'small') =>
  size === 'medium'
    ? MEDIUM_ACTION_ICON_BUTTON_SIZE
    : SMALL_ACTION_ICON_BUTTON_SIZE;

export const RedButton = styled(MarginButton)<{ $nothing?: boolean }>`
  background-color: ${(props) => props.theme.palette.error.dark};
  color: ${(props) => props.theme.palette.common.white};
`;

export const DualStateButton = styled(MarginButton)<{ $isEnabled?: boolean }>`
  background-color: ${(props) =>
    props.$isEnabled
      ? props.theme.palette.error.dark
      : props.theme.palette.success.light};
  color: ${(props) =>
    props.$isEnabled
      ? props.theme.palette.common.white
      : props.theme.palette.common.black};
`;

export const SmallLinkButtonStyle = css<ColoredButtonProps>`
  padding: 1px 5px;
  margin: 0px 10px 0px 0px;
  background-color: ${(props) => props.color};
  color: #fff;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;

  border: 1px solid ${(props: ColoredButtonProps) => props.color};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;

  &:hover {
    background-color: ${(props: ColoredButtonProps) => props.color};
    border-color: ${(props: ColoredButtonProps) => props.color};
    color: #fff;
    text-decoration: none;
  }
  &:active {
    background-color: ${(props: ColoredButtonProps) => props.color};
    border-color: ${(props: ColoredButtonProps) => props.color};
    color: #fff;
  }

  &:focus {
    color: #fff;
    background-color: ${(props: ColoredButtonProps) => props.color};
    border-color: ${(props: ColoredButtonProps) => props.color};
  }

  &:disabled {
    background-color: ${(props: ColoredButtonProps) => props.color};
    border-color: ${(props: ColoredButtonProps) => props.color};
    color: #fff;
    text-decoration: none;
  }
`;

export const StyledIconButton = css`
  color: #fff;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  min-width: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  max-width: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  height: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  min-height: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  max-height: ${SMALL_ACTION_ICON_BUTTON_SIZE};
  border-radius: 4px;
  padding: 0;
  margin-left: 6px;
  margin-bottom: 6px;
  font-size: 1em;
  box-shadow:
    0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
`;

export const StyledRedIconButton = css`
  ${StyledIconButton}
  background-color: ${(props) => props.theme.palette.error.dark};
`;

export const Icon = styled(FontAwesomeIcon)`
  font-size: 1em !important;
`;
